export const mapZIndex = {
  dotMarker: 1,
  labelMarker: 2,
  sponsoredMarker: 3,
  poiMarker: 4,
  hoveredMarker: 5,
  markerPopup: 8,
  updateControls: 10,
  filters: 11
}

export const markerCounts = {
  // desktop:
  max_markers: 250,
  max_sponsored_labels: 15,
  max_total_labels: 20,
  // mobile:
  max_markers_mobile: 100,
  max_sponsored_labels_mobile: 10,
  max_total_labels_mobile: 15
}

export const zoomLevels = {
  max: 18,
  default: 11,
  labelsOnAllMarkers: 14.5
}

export const defaultCoords = [49.256253658122446, -123.12404038633632]
